import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { TherapistClientDto } from '@therapist/shared/models/client/therapist-client.dto';
import { TherapistClientListItemDto } from '@therapist/shared/models/client/therapist-client-list-item.dto';
import { TherapistClientApiService } from '@therapist/shared/services/api/therapist-client-api.service';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TherapistClientStateService {

  readonly #therapistClientApiService = inject(TherapistClientApiService);

  readonly #selectedClient: WritableSignal<TherapistClientDto | null> = signal(null);
  readonly #clientList: WritableSignal<TherapistClientListItemDto[]> = signal([]);

  readonly #isClientLoaded: WritableSignal<boolean> = signal(false);

  constructor() {
    if (environment.enableStateLogging) {
      window.setInterval(() => {
        console.log('selected client', this.#selectedClient());
        console.log('is client loaded', this.#isClientLoaded());
      }, 2500);
    }
  }

  loadClientList(): void {
    this.#therapistClientApiService
      .getAll()
      .subscribe((data: TherapistClientListItemDto[]) => this.#clientList.set(data));
  }

  loadClientById(id: string): void {
    this.#isClientLoaded.set(false);

    this.#therapistClientApiService
      .getById(id)
      .subscribe((data: TherapistClientDto) => {
        this.setSelectedClient(data);
        this.#isClientLoaded.set(true);
      });
  }

  setSelectedClient(client: TherapistClientDto): void {
    this.#selectedClient.set(client);
    this.#isClientLoaded.set(true);
  }

  getSelectedClient(): Signal<TherapistClientDto | null> {
    return this.#selectedClient.asReadonly();
  }

  getClientList(): Signal<TherapistClientListItemDto[]> {
    return this.#clientList.asReadonly();
  }

  getIsClientLoaded(): Signal<boolean> {
    return this.#isClientLoaded.asReadonly();
  }

  removeAll(): void {
    this.#selectedClient.set(null);
    this.#clientList.set([]);
    this.#isClientLoaded.set(false);
  }
}
